function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from "react";
import classnames from "classnames";
import debounce from "lodash/debounce";
var svgIcon = function svgIcon(theme, size, customTheme) {
  var color = customTheme || (theme === "primary" ? "#3264FF" : "#F87F15");
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: '0 0 40 40',
    xmlns: 'http://www.w3.org/2000/svg'
  }, /*#__PURE__*/React.createElement("g", {
    fill: color,
    fillRule: 'evenodd'
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: '.6',
    cx: '20',
    cy: '3.333',
    r: '3.333'
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: '.4',
    transform: 'rotate(45 31.785 8.215)',
    cx: '31.785',
    cy: '8.215',
    r: '3.333'
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: '.2',
    transform: 'rotate(90 36.667 20)',
    cx: '36.667',
    cy: '20',
    r: '3.333'
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: '.4',
    transform: 'rotate(135 31.785 31.785)',
    cx: '31.785',
    cy: '31.785',
    r: '3.333'
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: '.6',
    transform: 'rotate(180 20 36.667)',
    cx: '20',
    cy: '36.667',
    r: '3.333'
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: '.8',
    transform: 'rotate(-135 8.215 31.785)',
    cx: '8.215',
    cy: '31.785',
    r: '3.333'
  }), /*#__PURE__*/React.createElement("circle", {
    transform: 'rotate(-90 3.333 20)',
    cx: '3.333',
    cy: '20',
    r: '3.333'
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: '.8',
    transform: 'rotate(-45 8.215 8.215)',
    cx: '8.215',
    cy: '8.215',
    r: '3.333'
  })));
};
function shouldDelay(spinning, delayNum) {
  return !!spinning && !!delayNum && !isNaN(Number(delayNum));
}
var Loading = function Loading(props) {
  var delay = props.delay,
    icon = props.icon,
    _props$size = props.size,
    size = _props$size === void 0 ? "default" : _props$size,
    _props$isLoading = props.isLoading,
    isLoading = _props$isLoading === void 0 ? true : _props$isLoading,
    customTheme = props.customTheme,
    tip = props.tip,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? "primary" : _props$theme,
    className = props.className,
    style = props.style;
  var prefixCls = "tc-loading";
  var _useState = useState(function () {
      return isLoading && !shouldDelay(isLoading, delay);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    spinning = _useState2[0],
    setSpinning = _useState2[1];
  var iconSize = {
    default: 40,
    middle: 60,
    large: 48,
    extra: 60
  };
  useEffect(function () {
    var updateSpinning = debounce(function () {
      setSpinning(isLoading);
    }, delay);
    updateSpinning();
    return function () {
      updateSpinning === null || updateSpinning === void 0 ? void 0 : updateSpinning.cancel();
    };
  }, [delay, isLoading]);
  var currentIcon = icon || svgIcon(theme, iconSize[size] || 40, customTheme);
  var loadingClassName = classnames("".concat(prefixCls), className);
  var loadingCompStyle = Object.assign({}, style);
  var tipsClassName = classnames("".concat(prefixCls, "-tip"), ["".concat(prefixCls, "-").concat(size)]);
  if (!spinning) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: loadingClassName,
    style: loadingCompStyle
  }, spinning && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-spin")
  }, currentIcon), !!tip && /*#__PURE__*/React.createElement("div", {
    className: tipsClassName
  }, tip));
};
export default Loading;